import { FC, useState, useEffect } from "react";
import { LieuType } from "data/types";
import Avatar2 from "shared/Avatar2/Avatar2";
import EvenementBtns2 from "components/EvenementBtns2";

import Axios from '../../_services/caller.service';
import { useTranslation } from 'react-i18next';

export interface CardLieuBoxProps {
  className?: string;
  symbole_monnaie: string;
  author: LieuType;
  index: string;
  onBlocNotesClick: (typeEvenement: string, idEvenement: number) => void;
  onConfirmClick: (typeEvenement: string, idEvenement: number) => void;
  onInfoClick: (placeId: string, placeNom: string, latitude: string, longitude: string) => void;
  onRechercheClick: (typeEvenement: string, idEvenement: number) => void;
  selected? : boolean;
  isMap?: boolean;
  onLocalisationClick?: () => void;
  numDroit: number;
}

const CardLieuBox: FC<CardLieuBoxProps> = ({
  className = "",
  symbole_monnaie,
  author,
  index,
  onBlocNotesClick,
  onConfirmClick,
  onInfoClick,
  onRechercheClick,
  selected,
  isMap,
  onLocalisationClick,
  numDroit
}) => {
  const { t } = useTranslation();

  const { displayName, libelle2, prix, type, paiement, avatar, lat, longi } = author;
  const [lienVisible, setLienVisible] = useState("");
  const [lienItineraire, setLienItineraire] = useState("");
  const [photo, setPhoto] = useState("");
  const [showOptions, setShowOptions] = useState<boolean>(false);


  useEffect(() => {

    //gestion lien lien_modifie si createur ou visiteur et etat=R pour créateur géré par l'api
    if(author.lien !== undefined && author.lien !== "" && numDroit ===1)
    {
      setLienVisible(author.lien);
    }
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien ==="V")
    {
      setLienVisible(author.lien);
    } 
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien === "M" && author.lien_modifie !== undefined && author.lien_modifie !== "")
    {
      setLienVisible(author.lien_modifie);
    }
    
    if(author.lat !== "" && author.longi !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir//"+author.lat+","+author.longi+"/");
    } 

  }, []);

  useEffect(() => {
   
   let imageURL: string | undefined;

    if(avatar !== "")
    {

      Axios.get(avatar, { responseType: 'blob' })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'image/jpeg' });
        imageURL = URL.createObjectURL(blob);
        setPhoto(imageURL);

      })
      .catch((error) => console.error('Erreur lors du chargement de l\'image', error));
    }
    else
    {
      setPhoto("");
    }

    return () => {
      if (imageURL) {
        URL.revokeObjectURL(imageURL); // Révoquez l'URL seulement lorsque le composant est démonté
      }
    };
    
  }, [avatar]);

  const afficheOptions = () => {
    setShowOptions(true);
  }

  const cacheOptions = () => {
    setShowOptions(false);
  }

  return (
  <div
    className={`
  ${selected ? "selectedCard" : ""}

  nc-CardLieuBox
  group
  relative
  w-full

  rounded-[30px]
  overflow-visible

  bg-[linear-gradient(145deg,rgba(255,255,255,0.98)_0%,rgba(255,255,255,0.94)_55%,rgba(248,250,252,0.96)_100%)]
  dark:bg-[linear-gradient(145deg,rgba(15,23,42,0.98)_0%,rgba(17,24,39,0.96)_55%,rgba(10,15,28,0.98)_100%)]

  border
  border-white/80
  dark:border-neutral-800

  shadow-[0_14px_32px_rgba(15,23,42,0.10),inset_0_1px_0_rgba(255,255,255,0.95)]
  hover:shadow-[0_18px_40px_rgba(15,23,42,0.14),inset_0_1px_0_rgba(255,255,255,0.95)]

  px-3
pt-4
pb-3

  transition-all
  duration-300
  ease-out
  hover:-translate-y-[2px]

  

  ${showOptions ? "z-[300]" : "z-1"}

  ${className}
`}
    data-nc-id="CardLieuBox"
    onMouseOver={afficheOptions}
    onMouseLeave={cacheOptions}
  >
   {/* couche visuelle de la card, clipsée aux coins */}
<div
  className="
    pointer-events-none
    absolute
    inset-0
    rounded-[30px]
    overflow-hidden
  "
>
  {/* effet bulle 3D : lumière douce */}
  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.95)_0%,transparent_38%),radial-gradient(circle_at_100%_100%,rgba(241,245,249,0.75)_0%,transparent_42%)]
      dark:bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.08)_0%,transparent_34%),radial-gradient(circle_at_100%_100%,rgba(255,74,82,0.08)_0%,transparent_42%)]
    "
  />

  {/* bordure intérieure glossy */}
  <div
    className="
      absolute
      inset-[1px]
      rounded-[29px]
      border
      border-white/80
      dark:border-white/10
    "
  />

  {/* ombre interne très subtile en bas */}
  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      shadow-[inset_0_-10px_22px_rgba(15,23,42,0.035)]
    "
  />
</div>
    {/* OPTIONS */}
    {(author.bloc !== "" ||
      author.document !== "" ||
      author.place_id !== "" ||
      lienVisible ||
      lienItineraire) && (
        
     <EvenementBtns2
  optionsVisibles={false}
  onCloseOptions={cacheOptions}
  onRechercheClick={type === "" ? onRechercheClick : undefined}
  onBlocNotesClick={author.bloc !== "" ? onBlocNotesClick : undefined}
  lienVisible={lienVisible}
  onConfirmClick={author.document !== "" ? onConfirmClick : undefined}
  onInfoClick={
    author.place_id && author.place_id !== "" && author.place_id !== "null"
      ? onInfoClick
      : undefined
  }
  placeId={author.place_id}
  placeNom={displayName}
  latitude={author.lat}
  longitude={author.longi}
  lienItineraire={lienItineraire}
  index={index || ""}
/>
    )}

    {/* HEADER : HEURE + BADGE TEXTE */}
   
{/* CONTENU PRINCIPAL */}
<div
  className={`
    relative
    z-10
    w-full
    text-left

    ${avatar !== "" && libelle2 !== "" ? "min-h-[78px]" : ""}
  `}
>

  {/* TITRE : pleine largeur, avec espace à droite pour le bouton options */}
  {displayName !== "" && (
    <h2
      className="
        pr-5
        text-center
        text-xs
        font-semibold
        text-neutral-900
        dark:text-white

        leading-snug
        break-words
      "
    >
      {displayName}
  {/* ICÔNES LOCALISATION EN MODE MAP */}
 {isMap && displayName !== "" && (lat === "" || longi === "") && (
  <>
    {" "}
    <span className="inline-flex align-middle">
      <i
        className="las la-location-arrow text-rose-500"
        data-tooltip-id="myTooltip"
        data-tooltip-content={t("coordonneesGPSAbsentes")}
        data-tooltip-place="top"
        onClick={
          numDroit === 1 || numDroit === 0
            ? () =>
                alert(
                  "Pour placer ce lieu, veuillez passer en mode modification."
                )
            : undefined
        }
      />
    </span>
  </>
)}

{isMap && displayName !== "" && lat !== "" && longi !== "" && (
  <>
    {" "}
    <span className="inline-flex align-middle">
      <i
        className="curseurPointeur las la-location-arrow text-green-500"
        data-tooltip-id="myTooltip"
        data-tooltip-content={t("cliquezCarte")}
        data-tooltip-place="top"
        onClick={onLocalisationClick}
      />
    </span>
  </>
)}

      </h2>
  )}

  
{/* DESCRIPTION + IMAGE */}
<div
  className={`
    mt-2
    flow-root
    text-xxs
    leading-tight
    text-neutral-500
    dark:text-neutral-400

    ${avatar === "" && libelle2 !== "" ? "text-center" : ""}
  `}
>
  {/* Cas 1 : image + description => image flottante à droite, comme aujourd'hui */}
  {avatar !== "" && libelle2 !== "" && (
    <Avatar2
      imgUrl={photo}
      alt={displayName}
      className="
        float-right

        w-[80px]
        h-[64px]

        ml-2
        mb-1

        rounded-[18px]
      "
      onImageClick={cacheOptions}
    />
  )}

  {/* Cas 2 : image seule => image centrée */}
  {avatar !== "" && libelle2 === "" && (
    <div className="flex w-full justify-center">
      <Avatar2
        imgUrl={photo}
        alt={displayName}
        className="
          w-[86px]
          h-[68px]

          rounded-[18px]
        "
        onImageClick={cacheOptions}
      />
    </div>
  )}

  {/* Cas 3 : description seule ou description + image */}
{libelle2 !== "" && (
  <div
    className={`
      max-w-full
      break-words
      [overflow-wrap:anywhere]
      ${avatar === "" ? "mx-auto max-w-[90%]" : ""}
    `}
    style={{ whiteSpace: "pre-line" }}
  >
    {libelle2}
  </div>
)}
</div>
</div>

    {/* PRIX */}
    {!isMap && prix !== "" && Number(prix) !== 0 && (
      <div
        className="
          mt-3
          pt-2
          clear-both

          border-t
          border-neutral-100
          dark:border-neutral-800

          flex
          items-center
          justify-between

          text-xs
          
          text-neutral-900
          dark:text-white
        "
      >
        <span >
          {prix} {symbole_monnaie}
        </span>

        <span>
          {paiement === "paye" && (
            <>
                Payé  <i
                        className="
                          las
                          la-check
                          text-xs
                          leading-none
                          text-emerald-500
                          drop-shadow-[0_1px_1px_rgba(16,185,129,0.35)]
                        "
                      />
            </>
          )}
        </span>
      </div>
    )}
  </div>
);
};

export default CardLieuBox;
